import React, { useState } from "react";
import { GdanskSaleForm } from "../../../models/GdanskSaleForm";
import { IoMdTime } from "react-icons/io";
import { format } from "date-fns";
import EAButton from "../../shared/Buttons/EAButton";

// Funkcja pomocnicza do wyciągania liczby z ciągu znaków
const extractNumberFromString = (str: string): number | null => {
  const match = str.match(/\d+/); // Szukamy pierwszej liczby w ciągu znaków
  return match ? parseInt(match[0], 10) : null; // Konwertujemy na liczbę, jeśli znaleziono
};

// Funkcja do generowania tablicy dat
const generateDateRange = (startDate: Date, daysQnt: number): Date[] => {
  const dates: Date[] = [];

  for (let i = 0; i < daysQnt; i++) {
    const newDate = new Date(startDate);
    newDate.setDate(startDate.getDate() + i); // Dodajemy kolejne dni
    dates.push(newDate);
  }

  return dates;
};

interface IProps {
  form: GdanskSaleForm;
}

const GdanskDatesInfo: React.FC<IProps> = ({ form }) => {
  const [showAllDates, setShowAllDates] = useState(false);
  const startDate = new Date(form.exercise.startTime);
  const daysQnt = extractNumberFromString(form.bookingGroupName ?? "");

  const isValidDate = !isNaN(startDate.getTime()); // Sprawdza, czy data jest poprawna
  const isValidDaysQnt = daysQnt !== null && daysQnt > 0; // Sprawdzamy, czy liczba dni jest prawidłowa

  const dates = isValidDate && isValidDaysQnt ? generateDateRange(startDate, daysQnt!) : [];

  const visibleDates = showAllDates ? dates : dates.slice(0, 8);

  if (isValidDate && isValidDaysQnt && dates.length > 0) {
    return (
      <div className="gdansk-input-content">
        <h5 className="no-line-height">Tym karnetem rezerwujesz terminy:</h5>
        <div className="gdansk-date-info-wrapper">
          {visibleDates.map((date, index) => (
            <div className="gdansk-single-date-info" key={index}>
              <p className="no-line-height">
                <IoMdTime /> {format(date, "dd.MM.yyyy HH:mm")}
              </p>
            </div>
          ))}
        </div>
        {dates.length > 8 && (
          <EAButton
            title={showAllDates ? "Pokaż mniej" : "Pokaż więcej"}
            onClick={() => setShowAllDates(!showAllDates)}
            variant="text"
            color="secondary"
          />
        )}
      </div>
    );
  } else {
    return <></>;
  }
};

export default GdanskDatesInfo;
